module.exports = __webpack_public_path__ + "static/media/edsider2.ee5414ea.svg";